import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

// Per-part zoom overrides for visualizerType "bvScene" — see the shape/unit docs in
// ../featureGroupZoomDefaults.ts (getFeatureZoomOverride). Bulk-ported (2026-08-15) from
// scss/bv/responsive-canvas-bvScene.scss's per-part `scale(X)` values. Seeded even though bvScene
// isn't on the docked canvas yet, so it's ready if/when that type moves over.
export function getBvSceneFeatureZoomOverride(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    case "accent_wall":
    case "threshold":
    case "vanity_backsplash":
    case "vanity_countertop":
    case "vanity_faucet":
    case "vanity_mirror":
    case "vanity_sink":
      return { scale: 1.3 };
    case "bathtub_liner":
    case "jetted_tub":
    case "replacement_tub":
    case "toilet":
    case "tub_common":
    case "walk_in_tub":
    case "shower_floor":
    case "shower_pan_combo":
      return { scale: 1.2 };
    case "left_wall":
    case "right_wall":
    case "front_wall":
    case "back_wall":
    case "split_wall":
    case "left_wall_splitter":
    case "bathroom_floor":
    case "shower_curb":
      return { scale: 1 };
    default:
      return undefined;
  }
}
